import React from "react";
import "./CoverTitle.css";
import "../../index.css";

const CoverTitle = ({
  title,
  children,
  class_Name,
  clr = "white",
  marginClass,
  textShadow,
  fontSize
}) => {
  return (
    <h2 className={`${clr && `${clr} ` } ${marginClass && marginClass} ${class_Name && class_Name } ${textShadow && textShadow} ${fontSize && fontSize}`}>{children || title}</h2>
  );
};

export default CoverTitle;